
export function getBytes2(buffer: Uint8Array, offset: number) {
    return (buffer[offset + 1] << 8) | buffer[offset]
}

export function setBytes2(buffer: Uint8Array, offset: number, value: number) {
    buffer[offset + 1] = value >> 8
    buffer[offset] = value & 0xff
}

export function getBit(byte: number, bit: number): 0 | 1 {
    return ((byte >> bit) & 1) as 0 | 1
}

export function setBit(byte: number, bit: number, value: number) {
    if (value)
        return byte | (1 << bit)
    else
        return byte & (~(1 << bit))
}

export function toHex(num: number, targetBytes: number = 0) {
    return '0x' + num.toString(16).padStart(targetBytes * 2, '0').toUpperCase()
}

export function toHexWithoutPrefix(num: number, targetBytes: number = 0) {
    return num.toString(16).padStart(targetBytes * 2, '0').toUpperCase()
}

export function overflowByte(num: number): number {
    num = num % 256
    if (num < 0)
        num += 256
    return num
}

export function overflowByte2(num: number): number {
    num = num % 65536
    if (num < 0)
        num += 65536
    return num
}

export function asSignedByte(num: number): number {
    if (num >= 128)
        num -= 256
    return num
}

export function checkHalfCarry(a: number, b: number) {
    return (((a & 0xf) + (b & 0xf)) & 0x10) == 0x10 ? 1 : 0
}

export function checkHalfBorrow(a: number, b: number) {
    return (a & 0x0f) < (b & 0x0f) ? 1 : 0
}

export function checkCarry(a: number, b: number) {
    return (((a & 0xff) + (b & 0xff)) & 0x100) == 0x100 ? 1 : 0
}

export function checkBorrow(a: number, b: number) {
    return (a & 0xff) < (b & 0xff) ? 1 : 0
}

export function checkHalfCarry2(a: number, b: number) {
    return (((a & 0xfff) + (b & 0xfff)) & 0x1000) == 0x1000 ? 1 : 0
}

export function checkCarry2(a: number, b: number) {
    return (((a & 0xffff) + (b & 0xffff)) & 0x10000) == 0x10000 ? 1 : 0
}

export function not(n: number) {
    return n == 0 ? 1 : 0
}

export function isZero(n: number) {
    return n == 0 ? 1 : 0
}